export const BARTER_RESOURCE = 'barter.entries';
export const BARTER_KEY = ['barter'] as const;

export type Direction = 'dalismy' | 'dostalismy';
export const DIRECTION_LABELS: Record<Direction, string> = { dalismy: 'Daliśmy', dostalismy: 'Dostaliśmy' };

/** A row of GET /api/barter (the balance only for whom may see it). */
export type ContractorBalance = { contractorId: string; name: string; open: boolean; balanceGrosze?: number; lastEntryOn: string };

/** An entry of GET /api/barter/contractors/:id (the value only for whom may see it). */
export type EntryView = {
  id: string;
  contractorId: string;
  contractorName: string;
  eventId: string | null;
  eventName: string | null;
  direction: Direction;
  description: string;
  valueGrosze?: number;
  occurredOn: string;
  source: 'reczny' | 'platnosc';
  version: number;
};

export type ContractorCard = { contractorId: string; name: string; balanceGrosze?: number; entries: EntryView[] };

/** "na naszą korzyść" (+: the contractor owes us) or "na ich korzyść". */
export const balanceSide = (grosze: number): string => (grosze > 0 ? 'na naszą korzyść' : 'na ich korzyść');
